/**
 * @fileoverview Togglable Hans features an org can control (Spec 11). Keys must
 * stay in sync with backend models.ORG_FEATURE_KEYS / org_service.FEATURE_DEFAULTS.
 */

export const ORG_FEATURES = [
  { key: "booking_page", label: "Public booking page", desc: "Let instructors share a self-booking link" },
  { key: "scheduling", label: "Scheduling", desc: "Weekly slots and reminders" },
  // student_portal_invites was RETIRED to a no-op (Spec 12 WP2) — the toggle no
  // longer gates anything, so it's dropped from the org UI.
  { key: "repertoire", label: "Repertoire assistant", desc: "AI repertoire teaching guides" },
  { key: "add_students", label: "Add students", desc: "Let instructors add students to their own roster" },
  // marketplace was RETIRED to a no-op — an org governs its own listings (via
  // each listing's `visibility`), not what its instructors may see of the wider
  // Hans community. Dropped from the org UI, like student_portal_invites.
  { key: "classes", label: "Classes", desc: "Let instructors create classes for group lessons" },
];

/**
 * Whether `key` is on for this instructor account-wide — mirrors the backend's
 * org_service.feature_enabled(user, key) with no org_id: enabled unless SOME
 * active membership disables it, and always enabled for a solo instructor.
 *
 * Spec 12 dropped account-wide nav-hiding because co-brand can't be resolved
 * across several orgs — but a *policy* answer still can, and hiding a dead
 * "Add student" button beats letting an instructor fill in the whole dialog to
 * earn a 403. The server gate remains authoritative; this is only cosmetic.
 */
export function accountFeatureEnabled(user, key) {
  return (user?.org_memberships || []).every((m) => m.features?.[key] !== false);
}
